import * as React from 'react';

export default React.createContext({
    cancelEverything: (propertyAssetId: string, tab: string) => {},
    returnToPreviousPage: () => {},
    returnTobBidDetailsPage: (propertyAssetId: string, biddingId: string) => {},
    returnToCompanyDetailsPage: (propertyAssetId: string, biddingId: string) => {},
    returnToFinanceDetails: (propertyAssetId: string, biddingId: string) => {},
});
